module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/system/system.component.scss
// module id = ./src/app/system/system.component.scss
// module chunks = main